<mat-sidenav-container class="sidenav-container">
    <mat-sidenav #drawer class="sidenav" fixedInViewport
                 [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
                 [mode]="(isHandset$ | async) ? 'over' : 'side'"
                 [disableClose]="(isHandset$ | async) === false"
                 [opened]="(isHandset$ | async) === false">
        <mat-toolbar>Menu</mat-toolbar>
        <mat-nav-list>
            @if ((permAccessUsersRead$ | async) || (permAccessRetailersRead$ | async)) {
                <mat-card-subtitle>Admin</mat-card-subtitle>
            }
            @if (permAccessUsersRead$ | async) {
                <a mat-list-item [routerLink]="['/users']">User list</a>
            }
            @if (permAccessRetailersRead$ | async) {
                <a mat-list-item [routerLink]="['/retailers']">Retailer list</a>
            }

            @if (permAccessModulesRead$ | async) {
                <mat-card-subtitle>Product</mat-card-subtitle>
            }
            @if (permAccessModulesRead$ | async) {
                <a mat-list-item [routerLink]="['/rule-templates']">Rule templates</a>
            }
            @if (permAccessModulesRead$ | async) {
                <a mat-list-item [routerLink]="['/blueprints']">Blueprints</a>
            }
            @if (permAccessModulesRead$ | async) {
                <a mat-list-item [routerLink]="['/module-categories']">Module Categories</a>
            }
            @if (permAccessModulesRead$ | async) {
                <a mat-list-item [routerLink]="['/attributes']">Attributes</a>
            }
            @if (permAccessMaterialsRead$ | async) {
                <a mat-list-item [routerLink]="['/materials']">Materials</a>
            }
            @if (permAccessMaterialsRead$ | async) {
                <a mat-list-item [routerLink]="['/textures']">Textures</a>
            }

            @if ((permAccessRetailersRead$ | async) || (permAccessModulesRead$ | async) ||
            (permAccessConfigurationsRead$ | async) || (permAccessRetailerDataRead$ | async)) {
                <mat-card-subtitle>
                    {{ (scopeService.currentScope$ | async)?.name }}
                </mat-card-subtitle>
            }
            @if (permAccessRetailerSettingsRead$ | async) {
                <a mat-list-item [routerLink]="['/retailer-settings']">Settings</a>
            }
            @if (permAccessEansRead$ | async) {
                <a mat-list-item [routerLink]="['/ean']">EAN</a>
            }
            @if (permAccessCatalogsRead$ | async) {
                <a mat-list-item [routerLink]="['/catalog']">Catalog</a>
            }
            @if (permAccessRetailersRead$ | async) {
                <a mat-list-item [routerLink]="['/translations']">Translations</a>
            }
            @if (permAccessConfigurationsRead$ | async) {
                <a mat-list-item [routerLink]="['/configuration']">Configurations</a>
            }
            @if (permAccessRetailerDataRead$ | async) {
                <a mat-list-item [routerLink]="['/retailer-data']">Retailer data download/upload</a>
            }
        </mat-nav-list>
        <div class="version font-overline">V{{ portalVersion }}</div>
    </mat-sidenav>
    <mat-sidenav-content>
        <mat-toolbar color="primary">
            @if (isHandset$ | async) {
                <button
                    type="button"
                    aria-label="Toggle sidenav"
                    mat-icon-button
                    (click)="drawer.toggle()"
                >
                    <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
                </button>
            }
            <span>Portal</span>
            <span class="spacer"></span>
            <button mat-button [matMenuTriggerFor]="scope">
                Scope: {{ (scopeService.currentScope$ | async)?.name }}
            </button>
            <mat-menu #scope="matMenu">
                @for (retailer of (scopeService.scopes$ | async); track $index) {
                    <button mat-menu-item
                            [ngClass]="{'active': retailer.id === (scopeService.currentScope$ | async).id}"
                            (click)="setScope(retailer)">{{ retailer.name }}
                    </button>
                }
            </mat-menu>
            <button mat-button
                    [matTooltip]="'topBar.tooltips.configurator' | translate"
                    (click)="openDraftPortal()">
                <mat-icon class="icon">open_in_browser</mat-icon>
            </button>
            <button mat-button
                    [matTooltip]="'topBar.tooltips.logout' | translate"
                    (click)="logout()">
                <mat-icon class="icon">logout</mat-icon>
            </button>
        </mat-toolbar>
        <div class="content">
            <router-outlet></router-outlet>
        </div>
    </mat-sidenav-content>
</mat-sidenav-container>
